@if (spec) {
    <div class="lm-builder-total-header-info">
        <p>{{ 'AddTotalsToNumericColumn' | translate }}</p>
        <svg soho-icon class="type-icon" [icon]="'info'" soho-tooltip [content]="'TotalsApplyToNumericColumns' | translate"/>
    </div>
    <div class="lm-builder-total-fields-container">
        <div
            class="lm-builder-display-field-boundary"
            cdkDropList
            [id]="LMBuilderModel.COLUMN_TOTAL_LIST"
            [cdkDropListConnectedTo]="[LMBuilderModel.FACADE_FIELD_PICKER_FIELDS_LIST]"
            [cdkDropListData]="LMBuilderModel.DISPLAY_FIELDS_LIST"
            [cdkDropListEnterPredicate]="canDrop"
            (cdkDropListDropped)="drop($event)">
            @if (totalFields.length > 0)   {
                @for (totalField of totalFields; track totalField.fieldId ) {
                    <div cdkDragBoundary="lm-builder-total-field-boundary" cdkDrag [cdkDragData]="totalField" class="lm-builder-total-fields-list-container">
                        <div *cdkDragPreview class="lm-builder-total-fields-list-container">
                            <svg cdkDragHandle soho-icon class="lm-builder-icon" [icon]="'drag'" soho-tooltip [content]="'DragMe' | translate"/>
                            <div><p>{{ totalField.fieldId }}</p></div>
                        </div>
                        <div class="lm-builder-total-field">
                            <p soho-tooltip [content]="totalField.fieldId" [attr.data-automation-id]="'lm-builder-column-total-field-text'">{{ totalField.operatorModels[0].displayField ? totalField.operatorModels[0].displayField.label.display : totalField.fieldId }}</p>
                        </div>
                        <div class="lm-builder-total-operators">
                            @for (operatorModel of totalField.operatorModels; track operatorModel.dai) {
                                <input
                                    soho-checkbox
                                    type="checkbox"
                                    [id]="operatorModel.dai"
                                    [attr.data-automation-id]="operatorModel.dai"
                                    [(ngModel)]="operatorModel.checked"
                                    [disabled]="false"
                                    (change)="updateTotalField(totalField, operatorModel)">
                                <label soho-label [for]="operatorModel.dai" [forCheckBox]="true" data-automation-id="lm-builder-column-total-label" class="lm-checkbox-label">{{operatorModel.label}}</label>
                            }
                        </div>
                    </div>
                }
                <div class="empty-title">
                    <div class="empty-title" soho-emptymessage
                         [info]="'AddNumericFieldsByDragging' | translate">
                    </div>
                </div>
            } @else {
                <div class="empty-title">
                    <div class="lm-builder-empty-message-container" soho-emptymessage
                         [title]="'NoColumnsToTotal' | translate"
                         [info]="'AddNumericFieldsByDragging' | translate">
                    </div>
                </div>
            }
        </div>
    </div>
}
